import { useMemo } from 'react'

import { PRAKTIK_KINERJA_STEP_ORDER } from 'app/KinerjaGpkPage/constants/praktik-kinerja-steps'
import { PraktikKinerjaStepCard } from 'app/KinerjaShared/components/PraktikKinerjaStepCard'

import type { StepCardStatus } from 'app/KinerjaShared/components/PraktikKinerjaStepCard'
import type { TStatePelaksanaan } from 'types/kinerja-pelaksanaan'

type PelaksanaanTindakLanjutStepCardProps = {
  currentState?: TStatePelaksanaan
}

const STEP: TStatePelaksanaan = 'DOCUMENT_REFLECTION_FOLLOW_UP'

/**
 * @deprecated Use `PelaksanaanTindakLanjutStepCard` from
 * `app/KinerjaShared/components/PraktikKinerjaPegawaiStepCards` for new
 * implementations across roles.
 */
export function PelaksanaanTindakLanjutStepCard({
  currentState,
}: PelaksanaanTindakLanjutStepCardProps) {
  // ----------------------------------------------------
  // Resolve step card status
  // ----------------------------------------------------
  const stepCardStatus: StepCardStatus = useMemo(() => {
    const currentStepIndex = PRAKTIK_KINERJA_STEP_ORDER.indexOf(currentState)
    const observasiStepIndex = PRAKTIK_KINERJA_STEP_ORDER.indexOf(STEP)

    if (currentStepIndex > observasiStepIndex) return 'completed'
    if (currentStepIndex === observasiStepIndex) return 'active'
    return 'locked'
  }, [currentState])

  return (
    <PraktikKinerjaStepCard
      className="max-w-96"
      iconSrc="/illustrations/img-smartphone-pop-up-modal-cart-section.png"
      status={stepCardStatus}
      lockedHint="Dilakukan setelah isi Rencana Tindak Lanjut."
      title={
        <>
          Pembinaan Kinerja: <br /> Pelaksanaan Tindak Lanjut
        </>
      }
      description="Laksanakan Pilihan Belajar dan tindak lanjut lainnya."
    />
  )
}
